"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryToCookie = exports.MINUTE_IN_MS = void 0;
/**
 * Move internal use querystring parameters into cookies to
 * simplify page params.
 */
exports.MINUTE_IN_MS = 6e4;
const queryToCookie = (req, res, paramsToConvert) => {
    const { nextUrl } = req;
    const convertedParams = [];
    paramsToConvert.forEach(key => {
        if (nextUrl.searchParams.has(key)) {
            nextUrl.searchParams.delete(key);
            /**
             * This is meant to be a transient cookie, if not properly cleaned up
             * it will expire in 30 minutes.
             */
            res.cookies.set(key, 'on', {
                sameSite: 'lax',
                maxAge: 30 * exports.MINUTE_IN_MS
            });
            convertedParams.push(key);
        }
    });
    return convertedParams.length > 0;
};
exports.queryToCookie = queryToCookie;
exports.default = exports.queryToCookie;
